(function () {
  var MAX_ATTEMPTS = 24;
  var DESKTOP_MIN_WIDTH = 1025;
  var resizeTimer;

  function isMobileCarousel() {
    return window.innerWidth < DESKTOP_MIN_WIDTH;
  }

  function parseGap(value) {
    return parseFloat(String(value || '0').replace('px', '')) || 0;
  }

  function getPageCount(slideCount, perView) {
    if (slideCount <= perView) return 1;
    return Math.floor((slideCount - 1) / perView) + 1;
  }

  function getActivePage(activeIndex, perView, pageCount) {
    var page = Math.floor(activeIndex / perView);
    return Math.max(0, Math.min(page, pageCount - 1));
  }

  function clearPagination(paginationEl) {
    if (!paginationEl) return;

    paginationEl.innerHTML = '';
    paginationEl.hidden = true;
    paginationEl.setAttribute('aria-hidden', 'true');
  }

  function buildGroupedPagination(swiper, paginationEl, perView) {
    var pageCount = getPageCount(swiper.slides.length, perView);

    paginationEl.innerHTML = '';
    paginationEl.classList.add('carousel__pagination--recommendations');
    paginationEl.setAttribute('role', 'tablist');

    if (pageCount <= 1) {
      paginationEl.hidden = true;
      paginationEl.setAttribute('aria-hidden', 'true');
      return;
    }

    paginationEl.hidden = false;
    paginationEl.setAttribute('aria-hidden', 'false');

    for (var i = 0; i < pageCount; i++) {
      (function (pageIndex) {
        var bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('aria-label', 'Show products page ' + (pageIndex + 1));
        bullet.addEventListener('click', function () {
          swiper.slideTo(pageIndex * perView);
        });
        paginationEl.appendChild(bullet);
      })(i);
    }

    function updateActive() {
      var activePage = getActivePage(swiper.activeIndex, perView, pageCount);
      paginationEl.querySelectorAll('.swiper-pagination-bullet').forEach(function (bullet, index) {
        bullet.classList.toggle('swiper-pagination-bullet-active', index === activePage);
        bullet.setAttribute('aria-current', index === activePage ? 'true' : 'false');
      });
    }

    swiper.off('slideChange', paginationEl._recommendationsUpdateActive);
    paginationEl._recommendationsUpdateActive = updateActive;
    swiper.on('slideChange', updateActive);
    updateActive();
  }

  function applyMobileCarouselConfig(swiper, slider, paginationEl) {
    var perView = parseFloat(slider.dataset.mobileSlides) || 1;
    var gap = parseGap(slider.dataset.mobileGap);

    swiper.params.spaceBetween = gap;
    swiper.params.slidesPerView = perView;
    swiper.params.slidesPerGroup = 1;
    swiper.params.threshold = 8;
    swiper.params.touchStartPreventDefault = false;
    swiper.params.watchOverflow = true;
    swiper.update();

    if (swiper.pagination && swiper.pagination.el) {
      swiper.pagination.destroy();
    }

    if (paginationEl) {
      buildGroupedPagination(swiper, paginationEl, perView);
    }
  }

  function applyDesktopCarouselConfig(swiper, slider, paginationEl) {
    var perView = parseFloat(slider.dataset.desktopSlides) || 1;
    var gap = parseGap(slider.dataset.desktopGap);

    swiper.params.spaceBetween = gap;
    swiper.params.slidesPerView = perView;
    swiper.params.slidesPerGroup = 1;
    swiper.params.threshold = 5;
    swiper.params.watchOverflow = true;
    swiper.update();

    if (swiper.pagination && swiper.pagination.el) {
      swiper.pagination.destroy();
    }

    clearPagination(paginationEl);
  }

  function setupRecommendationsCarousel(carousel) {
    var slider = carousel.querySelector('.carousel__slider-wrapper');
    var slides = carousel.querySelectorAll('.swiper-slide');
    var container = carousel.closest('.product-recommendations__container');
    var paginationEl = container && container.querySelector('[data-recommendations-pagination]');
    var mode = isMobileCarousel() ? 'mobile' : 'desktop';

    if (!slider || slides.length <= 1 || !window.dAgency?.initCarousel) return false;

    if (
      slider.dataset.recommendationsCarouselReady === 'true' &&
      slider.dataset.recommendationsCarouselMode === mode
    ) {
      return true;
    }

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
      slider.classList.remove('swiper-initialized');
    }

    window.dAgency.initCarousel(carousel);

    var swiper = slider.swiper;
    if (!swiper) return false;

    if (mode === 'mobile') {
      applyMobileCarouselConfig(swiper, slider, paginationEl);
    } else {
      applyDesktopCarouselConfig(swiper, slider, paginationEl);
    }

    slider.dataset.recommendationsCarouselReady = 'true';
    slider.dataset.recommendationsCarouselMode = mode;
    return true;
  }

  function initProductTiles(container) {
    if (typeof window.dAgency?.initProductTile !== 'function') return;

    container.querySelectorAll('.product-tile__container').forEach(function (tile) {
      window.dAgency.initProductTile(tile);
    });
  }

  function initCarousels() {
    var didInit = false;

    document.querySelectorAll('.product-recommendations__container .carousel__container').forEach(function (carousel) {
      if (setupRecommendationsCarousel(carousel)) {
        didInit = true;
      }
    });

    return didInit;
  }

  function getSectionId(section) {
    if (section.classList.contains('custom-product-recommendations__section')) {
      return 'custom-product-recommendations';
    }

    return 'product-recommendations';
  }

  function loadRecommendations(section) {
    var container = section.querySelector('.product-recommendations__container');
    if (!container || container.dataset.recommendationsLoaded === 'true') return Promise.resolve();

    var productId = container.dataset.productId;
    if (!productId) return Promise.resolve();

    container.dataset.recommendationsLoaded = 'true';

    var sectionId = getSectionId(section);
    var url =
      window.Shopify.routes.root +
      'recommendations/products?product_id=' +
      productId +
      '&limit=12&intent=related&section_id=' +
      sectionId;

    return fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fetchedContainer = parsed.querySelector('.product-recommendations__container');

        if (!fetchedContainer || fetchedContainer.querySelectorAll('.product-tile__container').length === 0) {
          return;
        }

        container.innerHTML = fetchedContainer.innerHTML;
        initCarousels();
        initProductTiles(container);
        window.dispatchEvent(new CustomEvent('refreshLinkProxy'));
      })
      .catch(function () {
        container.dataset.recommendationsLoaded = '';
      });
  }

  function bootSections() {
    document.querySelectorAll('.custom-product-recommendations__section').forEach(function (section) {
      loadRecommendations(section);
    });

    document.querySelectorAll('.product-recommendations__section').forEach(function (section) {
      loadRecommendations(section);
    });

    initCarousels();
  }

  function boot(attempt) {
    bootSections();

    if (
      attempt < MAX_ATTEMPTS &&
      document.querySelector(
        '.product-recommendations__container .carousel__slider-wrapper:not([data-recommendations-carousel-ready])'
      )
    ) {
      window.setTimeout(function () {
        boot(attempt + 1);
      }, 250);
    }
  }

  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll('.product-recommendations__container .carousel__container').forEach(function (carousel) {
        var slider = carousel.querySelector('.carousel__slider-wrapper');
        if (!slider || slider.dataset.recommendationsCarouselReady !== 'true') return;

        var mode = isMobileCarousel() ? 'mobile' : 'desktop';
        if (slider.dataset.recommendationsCarouselMode !== mode) {
          slider.dataset.recommendationsCarouselReady = '';
          setupRecommendationsCarousel(carousel);
        }
      });
    }, 150);
  }

  function start() {
    boot(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('resize', handleResize);
  document.addEventListener('shopify:section:load', start);
})();
